import React from "react";
import { SearchOutlined, WhatsAppOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import efficientBg from "../assets/images/efficient-1.webp";
import bannerTop from "../assets/images/banner-top.svg";
import {
    Avatar,
    Col,
    Flex,
    Row,
    Card,
    Button,
    Rate,
    Tag,
    Carousel,
    Image,
    Space,
    Typography,
} from "antd";
import logo from "../assets/images/efficient-logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ExploreTopThingsToDoDubai from "./ExploreTopThingsToDoDubai";
import Header from "./Header";
import SearchDropdown from "./SearchDropdown";
import ExploreTopThingsToDoCountry from "./ExploreTopThingsToDoCountry";
import Footer from "./Footer";

const LandingPage = () => {
    const classvalue = 'landingpage-header'
    return (
        <>
            <div className="min-h-[calc(100vh-100px)] relative overflow-hidden mb-6">

                {/* ================= HERO BACKGROUND ================= */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url(${bannerTop})`,
                    }}
                />

                <Header classvalue='whiteheaderlandingpage' />



                {/* ================= HERO CONTENT ================= */}
                <main className="relative z-10 min-h-[calc(100vh-100px)] flex items-center justify-center">

                    <div className="text-center text-white w-full max-w-[900px] px-6">

                        {/* HEADING */}
                        <h1 className="text-[32px] md:text-[38px] leading-[1.2] font-normal mb-5">
                            Discover Your Next Adventure.
                            <br />
                            Your Journey Starts Here.
                        </h1>

                        {/* SUB HEADING */}
                        <p className="text-[16px] md:text-[17px] leading-[1.4] font-light max-w-[650px] mx-auto">
                            Explore the World's Most Beautiful Destinations and Turn
                            <br className="hidden md:block" />
                            Every Journey Into an Unforgettable Experience
                        </p>

                        {/* SEARCH */}
                        <div className="relative z-[9999] mt-6 flex justify-center">

                            <SearchDropdown size="h-16" />

                        </div>

                    </div>

                </main>



            </div>

            <section className="py-4 px-4 lg:px-0">
                <div className="container">
                    <ExploreTopThingsToDoCountry
                        filterBy="country"
                        countryName="United Arab Emirates"
                    />
                </div>
            </section>

            <section className="py-4 px-4 lg:px-0">
                <div className="container">
                    <ExploreTopThingsToDoCountry
                        filterBy="country"
                        countryName="France"
                    />
                </div>
            </section>

            <Footer />
        </>
    );
};

export default LandingPage;